export const SETTLEMENT_STATUSES = {
  SETTLED: 'SETTLED',
  HOLD: 'HOLD',
  FAILED: 'FAILED',
  UNSETTLED: 'UNSETTLED',
} as const;

export type SettlementStatus = keyof typeof SETTLEMENT_STATUSES;

export const getSettlementStatusColor = (status: SettlementStatus): string => {
  switch (status) {
    case 'SETTLED':
      return 'success';
    case 'UNSETTLED':
      return 'warning';
    case 'FAILED':
      return 'error';
    case 'HOLD':
      return 'info';
    default:
      return 'default';
  }
};
